import React from 'react';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCw, Trash2 } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.href = '/login';
  };

  handleClearAndReset = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    this.setState({ hasError: false, error: null });
    window.location.href = '/login';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-zinc-950 p-4">
          <div className="max-w-md w-full bg-zinc-900 border border-zinc-800 rounded-xl p-8 text-center space-y-6">
            <div className="mx-auto w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center">
              <AlertTriangle className="w-8 h-8 text-red-500" />
            </div>
            <div>
              <h2 className="text-xl font-bold text-white mb-2">Application Error</h2>
              <p className="text-zinc-400 text-sm">
                An unexpected error occurred. This may be caused by a version mismatch between frontend and backend.
              </p>
            </div>
            <div className="bg-zinc-800/50 rounded-lg p-3 text-left">
              <p className="text-xs text-zinc-500 font-mono break-all">
                {this.state.error?.message || 'Unknown error'}
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Button onClick={this.handleClearAndReset} className="w-full" data-testid="error-clear-reset-btn">
                <Trash2 className="w-4 h-4 mr-2" />
                Clear Session & Retry
              </Button>
              <Button onClick={this.handleReset} variant="outline" className="w-full" data-testid="error-retry-btn">
                <RefreshCw className="w-4 h-4 mr-2" />
                Retry
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
